import { RunnerUpHeader} from "../../ui";
import * as XLSX from "xlsx";
import Button from "../../library/components/Button";
import UploadFile from "../../library/components/FileUpload";
import { Validators } from "../../library/utilities/Validator";
import React, { useRef, useState } from "react";
import pdfIcon from "../../images/pdfIcon.png";
import excelIcon from "../../images/excelIcon.png";
import {
  useFinalizeServicevoterUploadFileMutation,
  useGetServiceVoterDataQuery,
} from "../../services/finalizeGenerateViewTransmitService";
import { useDispatch } from "react-redux";
import { BROWSER_NOT_SUPPORT } from "../../constants/constants";
import { createAlert } from "../../features/alert/alerts";
import {
  ALERT_TYPE_SUCCESS,
  ALERT_TYPE_ERROR,
  ALERT_TYPE_INFO,
} from "../../constants/constants";
import { useEffect } from "react";
import { downloadPdfFile, parseJwt } from "../utilities/utils";
// import { useGetAcsQuery } from "../../services/commonService";
import { isExcelValid } from "./SV_Validations";
import SpinnerWithButton from "../../library/components/SpinnersWithButton";
import CustomModal from "../../library/components/Modal/modal";
import ConfirmationModal from "../../library/components/FileUpload/ConfirmationModal/ConfirmationModal";
import { downloadExcel } from "react-export-table-to-excel";
import Table from "../../ui/datatable/DataTable";
import { useSendotpMutation } from "../../services/ERO_management/otpservice";
import VerifytOtp from "../MasterAdmin/UserList/VerifyOtp";
import { useGetElectionDetailsQuery } from "../../services/announceElection";
import moment from "moment";
import NoElection from "../NoElection";
import scannerImage from "../../images/scanner.png";
import WorkingFlipDate from "../../library/components/WorkingFlipDate/WorkingFlipDate";
import RunnerUpHeaderNew from "../../ui/runnerUpHeader/RunnerUpHeaderNew";
const tableHeader = [
  "S.No.",
  "State Code",
  "AC No.",
  "Serial No. In part",
  "Full Name",
  "Address",
  "Age",
  "Record Office ID",
];
const templateTableHeader = [
  "ST_CODE",
  "AC_NO",
  "SLNOINPART",
  "FULL_NAME",
  "EPIC_NUMBER",
  "AADHAAR_NUMBER",
  "MOBILENO",
  "EMAILID",
  "PASSPORT_NO",
  "ADDRESS",
  "IDCARDNO",
  "SERVICE_NO",
  "HNBSNO",
  "SRVC_CATY",
  "BUCKLE_NO",
  "RANK",
  "SERVICE_REG",
  "FORCE_ID",
  "RECORD_OFFICE_CODE",
  "UNIT_OFFICE_CODE",
  "DOB",
  "AGE",
  "SEX",
];
const FinalizeService = () => {
  const mobileNo = localStorage?.access_token && parseJwt(localStorage?.access_token)?.phone_number;
  const [otpsend] = useSendotpMutation();
  const [screenShowing, setScreenShowing] = useState(true);
  const [screenShowingMessage, setScreenShowingMessage] = useState();
  const [VerifyModal, setVerifyModal] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [
    showConfirmationPopupForNoVoters,
    setShowConfirmationPopupForNoVoters,
  ] = useState(false);
  const [spinIsLoading, setSpinIsLoading] = useState(false);
  const uploadFileRef = useRef();
  const [newFile, setnewFile] = useState("");
  const [isSVDSkip, setIsSVDSkip] = useState(true);
  const { data: serviceVoters, refetch } = useGetServiceVoterDataQuery("", {
    skip: isSVDSkip,
  });
  const [uploadFile, datap] = useFinalizeServicevoterUploadFileMutation();
  const { data: getAnnounceElectionDetail, isSuccess, refetch:refetchServerDate } =
    useGetElectionDetailsQuery("Ero");
  const [isFinalizeButton, setFinalizeButton] = useState(false);
  const regex = /^([a-zA-Z0-9\s_\\.\-:()])+(.xls|.xlsx)$/;
  const [isShowing, setIsShowing] = useState(true);
  const [totalNoOfRecords, setTotalNoOfRecords] = useState();
  const [error, seterror] = useState({});
  const [tableData, setTableData] = useState([]);
  const [
    announceElectionErollFinalizationDate,
    setAnnounceElectionErollFinalizationDate,
  ] = useState();
  const [finalizedData, setFinalizeddata] = useState([]);
  const [isFileUpload, setIsFileUpload] = useState(false);
  const [Error, setError] = useState({});
  const [exeldata, setexeldata] = useState([]);
  const [count, setCount] = useState(0);
  const [finalizedCount, setfinalizedCount] = useState(0);
  const dispatch = useDispatch();
  const ac_No = parseJwt(localStorage.access_token)?.authorizedAcs?.[0];
  const stateCd = parseJwt(localStorage.access_token)?.authorizedStates?.[0];
  const [isDataFinalized, setIsDataFinalized] = useState(false);
  const templateTableData = [
    {
      ST_CODE: "String(3)",
      AC_NO: "Int",
      SLNOINPART: "Int",
      FULL_NAME: "String",
      EPIC_NUMBER: "String",
      AADHAAR_NUMBER: "String",
      MOBILENO: "String",
      EMAILID: "String",
      PASSPORT_NO: "String(8)",
      ADDRESS: "String",
      IDCARDNO: "String(30)",
      SERVICE_NO: "String(30)",
      HNBSNO: "Int",
      SRVC_CATY: "String(1)",
      BUCKLE_NO: "String",
      RANK: "String",
      SERVICE_REG: "String",
      FORCE_ID: "String(5)",
      RECORD_OFFICE_CODE: "String",
      UNIT_OFFICE_CODE: "String",
      DOB: "String(10)",
      AGE: "Int",
      SEX: "String(1)",
    },
  ];
  const columns = [
    {
      Header: "S.No",
      accessor: "serialNumber",
    },
    {
      Header: "State Code",
      accessor: "stateCd",
    },
    {
      Header: "AC No.",
      accessor: "assemblyConstituencyNumber",
    },
    {
      Header: "Serial No. In part",
      accessor: "slNoInPart",
    },
    {
      Header: "Full Name",
      accessor: "fullName",
    },
    {
      Header: "Address",
      accessor: "address",
    },
    {
      Header: "Age",
      accessor: "age",
    },
    {
      Header: "Record Office ID",
      accessor: "recordOfficeCode",
    },
  ];
  const distCd = localStorage?.access_token && parseJwt(localStorage?.access_token)?.authorizedDistricts?.[0]
  // const { data: getACs } = useGetAcsQuery(distCd)

  useEffect(() => {
    // if (getAnnounceElectionDetail?.payload) {
    //   setAnnounceElectionErollFinalizationDate(
    //     getAnnounceElectionDetail?.payload?.[0]?.erollFinalDateTime
    //   );
    // }
    setIsSVDSkip(getAnnounceElectionDetail?.payload?.[0]?.timerVariable)
  }, [getAnnounceElectionDetail]);

  useEffect(() => {
    if (serviceVoters?.payload?.length) {
      setError({ uploadFile: "Data has been finalized already." });
      setexeldata(serviceVoters?.payload);
      setIsDataFinalized(true);
      setfinalizedCount(serviceVoters?.payload?.length);
    } else if (
      serviceVoters?.message &&
      String(serviceVoters?.message).includes("No")
    ) {
      setError({ uploadFile: serviceVoters?.message });
      // setexeldata([])
      setIsDataFinalized(true);
      // setfinalizedCount(serviceVoters?.payload?.length)
    }
  }, [serviceVoters]);

  useEffect(() => {
    setCount(exeldata.length);
  }, [exeldata]);

  useEffect(() => {
    let tData = [];
    let FinalizedData = [];
    if (isDataFinalized) {
      exeldata?.map((item, i) => {
        tData.push({
          serialNumber: i + 1,
          stateCd: item.stateCode,
          assemblyConstituencyNumber: item.assemblyConstituencyNumber,
          slNoInPart: item.slNoInPart,
          fullName: item.fullName,
          address: item.address,
          age: item.age,
          recordOfficeCode: item.recordOfficeCode,
        });
      });
    } else {
      exeldata?.map((item, i) => {
        tData.push({
          serialNumber: i + 1,
          stateCd: item.ST_CODE,
          assemblyConstituencyNumber: item.AC_NO,
          slNoInPart: item.SLNOINPART,
          fullName: item.FULL_NAME,
          address: item.ADDRESS,
          age: item.AGE,
          recordOfficeCode: item.RECORD_OFFICE_CODE,
        });
      });
      exeldata?.map((item, i) => {
        FinalizedData.push({
          serialNumber: i + 1,
          stateCd: item.ST_CODE,
          acNo: item.AC_NO,
          slNoInPart: item.SLNOINPART,
          fullName: item.FULL_NAME,
          address: item.ADDRESS,
          age: item.AGE,
          recordOfficeCode: item.RECORD_OFFICE_CODE,
          aadharNumber: parseInt(item.AADHAAR_NUMBER),
          buckleNumber: item.BUCKLE_NO,
          epicNumber: item.EPIC_NUMBER,
          dob: item.DOB,
          electionType: item.ELEC_TYPE,
          emailId: item.EMAILID,
          forceId: item.FORCE_ID,
          hnbsNumber: parseInt(item.HNBSNO),
          idCardNumber: item.IDCARDNO,
          mobileNumber: parseInt(item.MOBILENO),
          passportNumber: item.PASSPORT_NO,
          rank: item.RANK,
          serviceNumber: item.SERVICE_NO,
          serviceReg: item.SERVICE_REG,
          sex: item.SEX,
          serviceCategory: item.SRVC_CATY,
          unitOfficeCode: item.UNIT_OFFICE_CODE,
        });
      });
    }
    setTableData(tData);
    setTotalNoOfRecords(exeldata?.length);
    setFinalizeddata(FinalizedData);
  }, [exeldata]);

  const changeHandler = (event) => {
    setnewFile(event.target.files[0]);
  };

  const processExcel = (data) => {
    const workbook = XLSX.read(data, { type: "binary" });
    const firstSheet = workbook.SheetNames[0];
    const excelRows = XLSX.utils.sheet_to_row_object_array(
      workbook.Sheets[firstSheet]
    );
    let isValid = true;
    for (let i = 0; i < excelRows.length; i++) {
      isValid = isExcelValid(excelRows[i], i + 1, stateCd, ac_No, onInfo);
      if (!isValid) break;
    }

    if (isValid) {
      setCount(exeldata.length);
      setIsFileUpload(true);
      setFinalizeButton(true);
      setexeldata(excelRows);
    } else {
      setexeldata([]);
      setIsFileUpload(false);
      setFinalizeButton(false);
      setCount(0);
    }

    setSpinIsLoading(false);
  };

  const onExcelUpload = () => {
    let error = {};
    if (!newFile || newFile === "") {
      error["uploadFile"] = "Please Upload a file";
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }
    setSpinIsLoading(true);
    const fileUpload = document.getElementById("inputFile");
    if (regex.test(fileUpload.value.toLowerCase())) {
      if (typeof FileReader !== "undefined") {
        const reader = new FileReader();
        if (reader.readAsBinaryString) {
          reader.onload = (e) => {
            processExcel(reader.result);
          };
          reader.readAsBinaryString(fileUpload.files[0]);
          setIsShowing(true);
          uploadFileRef.current.removeFile();
        }
      } else {
        alert(BROWSER_NOT_SUPPORT);
        document.getElementById("inputFile").value = "";
      }
    }
  };

  const onNoVotersInConst = () => {
    uploadFile([])
      .unwrap()
      .then((res) => {
        onSuccess(res.message);
        refetch();
        document.getElementById("inputFile").value = "";
        setFinalizeButton(false);
        setIsShowing(true);
        setCount(0);
      })
      .catch((error) => {});

    setShowConfirmationPopupForNoVoters(false);
  };
  // useEffect(() => {
  //   if (announceElectionErollFinalizationDate) {
  //     let currentDate = moment(new Date()).format('MM-DD-YYYY HH:mm:ss');
  //     let erollFinalizationDate = moment(new Date(announceElectionErollFinalizationDate)).format('MM-DD-YYYY HH:mm:ss');
  //     if (currentDate < erollFinalizationDate) {
  //       setScreenShowing(false);
  //       setScreenShowingMessage(`Service voter list can be uploaded after the last date of nomination: ${moment(new Date(erollFinalizationDate)).format("DD-MMMM-YYYY hh:mm A")}`)
  //     }
  //     else
  //     {
  //       setScreenShowing(true);
  //       setScreenShowingMessage("");
  //     }

  //   }

  // }, [announceElectionErollFinalizationDate])

  const onFinalize = () => {
    if (tableData.length !== 0) {
      uploadFile(finalizedData)
        .unwrap()
        .then((res) => {
          onSuccess(res.message);
          refetch();
          document.getElementById("inputFile").value = "";
          // setDeleteFileFlag(false)
          setFinalizeButton(false);
          setIsShowing(true);
          setCount(0);
          // setnewFile("")
        })
        .catch((error) => {});
    } else {
      onInfo("Please Upload the File First !");
    }
    setShowConfirmationPopup(false);
  };

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: "Success",
      })
    );
  };

  const onInfo = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_INFO,
        heading: "Info",
      })
    );
  };

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };
  const handleTemplateDownload = () => {
    downloadExcel({
      fileName: "Service Voter Template",
      sheet: "Service Voter Template",
      tablePayload: {
        header: templateTableHeader,
        body: templateTableData,
      },
    });
  };
  const onHandleDownload = () => {
    downloadExcel({
      fileName: "Finalized Voters",
      sheet: "FinalizedVoters",
      tablePayload: {
        header: tableHeader,
        body: tableData,
      },
    });
  };
  const handleOpen = () => {
    setShowConfirmationPopupForNoVoters(false);
    uploadFile([])
      .unwrap()
      .then((res) => {
        onSuccess(res.message);
          refetch();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const refreshDate = ()=>{
    refetchServerDate()
  }


  return isSuccess && getAnnounceElectionDetail?.message === "Success" ? (
    getAnnounceElectionDetail && (
      <WorkingFlipDate 
      hours={getAnnounceElectionDetail?.payload?.[0]?.hours} 
      minutes={getAnnounceElectionDetail?.payload?.[0]?.minutes} 
      days={getAnnounceElectionDetail?.payload?.[0]?.days}
      seconds={getAnnounceElectionDetail?.payload?.[0]?.seconds}
      image={false}
      message={"Left for Service voter uploading process to start"}
      messageClass={"returningOfficer_countdown"}
      disable={getAnnounceElectionDetail?.payload?.[0]?.timerVariable}
      refreshDate={refreshDate}
      >
        <>
          {spinIsLoading && (
            <div className="globalSpinnerDiv">
              <SpinnerWithButton spinnerClass="globalSpinner" />
            </div>
          )}
          {
            <CustomModal
              className="confirmation_modal"
              show={showConfirmationPopup}
              onClose={() => {
                setShowConfirmationPopup(false);
              }}
              size="500px"
              closeIcon={false}
              modalTitle={"Do you want to finalize ?"}
              children={
                <ConfirmationModal
                  // title="You want to delete this"
                  noOption={() => {
                    setShowConfirmationPopup(false);
                  }}
                  yesOption={onFinalize}
                />
              }
            />
          }
          {
            <CustomModal
              className="confirmation_modal"
              show={VerifyModal}
              onClose={() => {
                setVerifyModal(false);
              }}
              size="500px"
              closeIcon={false}
              modalTitle={
                "Are you sure there are no service voter in your constituency?"
              }
              children={
                <VerifytOtp
                  onSuccess={() => {
                    setVerifyModal(false);
                    onNoVotersInConst();
                  }}
                />
              }
            />
          }
          {
            <CustomModal
              className="confirmation_modal"
              show={showConfirmationPopupForNoVoters}
              onClose={() => {
                setShowConfirmationPopupForNoVoters(false);
              }}
              size="500px"
              closeIcon={false}
              modalTitle={
                "Are you sure there are no Service Voters in your constituency ?"
              }
              children={
                <ConfirmationModal
                  // title="You want to delete this"
                  noOption={() => {
                    setShowConfirmationPopupForNoVoters(false);
                  }}
                  yesOption={handleOpen}
                />
              }
            />
          }

          <div className="container box shadow ">
            <div className="col-md-12">
              <div className="strip">
                <div
                  className="row col-md-12"
                  style={{ justifyContent: "space-between" }}
                >
                  <div className="">
                    <div>
                      <label
                        style={{ paddingRight: "30px", paddingLeft: "7px" }}
                      >
                        AC NO. & Name-:
                      </label>
                      <strong className="pl-1">
                        {serviceVoters?.constituencyNumber}-{" "}
                        {
                         serviceVoters?.constituencyName
                        }
                      </strong>
                    </div>
                  </div>
                  <div>
                    <div>
                      <label className="" style={{ paddingRight: "30px" }}>
                        Total Service Voters Uploaded & Finalised-:
                      </label>
                      <strong
                        className={
                          finalizedCount > 0 ? "text-success" : "text-warning"
                        }
                      >
                        {finalizedCount}
                      </strong>
                    </div>
                  </div>
                  {finalizedCount > 0 && isDataFinalized ? (
                    <div style={{ paddingLeft: "11px", marginTop: "-4px" }}>
                      <img
                        style={{ cursor: "pointer" }}
                        src={pdfIcon}
                        width="37px"
                        height="31px"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Download Uploaded List in pdf"
                        onClick={() =>
                          downloadPdfFile(
                            "Finalized Voters",
                            tableHeader,
                            tableData
                          )
                        }
                      />
                      <img
                        style={{ cursor: "pointer" }}
                        src={excelIcon}
                        width="40px"
                        height="35px"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Download Uploaded List in Excel"
                        onClick={onHandleDownload}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            {screenShowing ? (
              <>
                <div className="col-md-12">
                  <RunnerUpHeaderNew
                    title={"Finalize Service Voter"}
                    state={serviceVoters?.state}    
                  
                    // search={
                    //   <div
                    //     className="col-md-4"
                    //     style={{ display: "flex", justifyContent: "end" }}
                    //   >
                    //     <button
                    //       type="button"
                    //       className="btn btn-light btn-sm announce_election_excel_template1 "
                    //       onClick={handleTemplateDownload}
                    //     >
                    //       Download Template
                    //       <span className="pl-2">
                    //         <i class="fa-solid fa-download"></i>
                    //       </span>
                    //     </button>
                    //   </div>
                      
                    // }
                  />
                </div>
                <>
                  <div className="col-md-4">
                    <label>Upload Service Voters Details (in Excel)</label>
                  </div>
                  <div className="row">
                    <div className="col-md-5">
                      <div></div>
                      <UploadFile
                        reference={uploadFileRef}
                        id="inputFile"
                        name="uploadFile"
                        labelClass="col-md-12"
                        inputClass="col-md-12"
                        validTypes={[".xlsx", ".xls"]}
                        accept=".xlsx,.xls"
                        onChange={(ev) => changeHandler(ev, "uploadFile")}
                        required={true}
                        // size={2000}
                        getError={(val) => getError("uploadFile", val)}
                        Error={Error}
                        seterror={seterror}
                        disabled={isDataFinalized}
                        // resetFile={() => resetFile("uploadFile")}
                        validators={[
                          {
                            check: Validators.required,
                            message: "This field is required",
                          },
                        ]}
                      />
                    </div>
                    <div className="col-md-4 pl-0 upload-row mb-2">
                      {Object.keys(error).length !== 0 ? (
                        ""
                      ) : (
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary btn-sm upload-master-button"
                            onClick={onExcelUpload}
                            hidden={isDataFinalized}
                          >
                            upload
                            <span className="pl-2">
                              <i class="fa-solid fa-upload"></i>
                            </span>
                          </button>
                          <p className="text-danger">
                            (only .xls and .xlsx extension supported)
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="col-md-12">
                      <div className="row mt-1">
                        <div className="col-md-3 ml-3">
                          <label>Total No. of Service Voters</label>
                        </div>

                        <div className="col-md-8">
                          <strong>{count}</strong>
                        </div>
                      </div>
                      {isShowing ? (
                        <div
                          className="col-md-12"
                          style={{ marginTop: "-30px" }}
                        >
                          <Table
                            placeholder="Search"
                            globalsearch={true}
                            selectall={true}
                            emptyMessage="No Record Found"
                            columns={columns}
                            records
                            data={tableData?.length === 0 ? [] : tableData}
                            size={5}
                            tableClassNameCheck="contenttable-eroll"
                            pagination
                            gotopage
                            rows
                            numberrows={totalNoOfRecords}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {isFinalizeButton && !isDataFinalized ? (
                        <div className="finalize_button col-md-2">
                          <Button
                            className="btn-class"
                            value="Finalize"
                            onClick={() => setShowConfirmationPopup(true)}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </>
              </>
            ) : (
              <h4 className="text-warning text-center">
                {screenShowingMessage}
              </h4>
            )}
          </div>
          {screenShowing ? (
            !isDataFinalized ? (
              <div className="container box">
                {/* <div class="card-header">
            Featured
          </div> */}
                <div className="card-body">
                  {/* <h5 className="card-header">Special title treatment</h5> */}
                  <p className="card-text">
                    In case there are no service voters in your constituency{" "}
                    <b>
                    {ac_No}-{" "}
                    {
                      // getACs?.filter((item) => item.asmblyNo === ac_No)?.[0]
                      //   ?.asmblyName
                      serviceVoters?.constituencyName
                    }
                    </b>
                    , Please click on the button below and finalize the same{" "}
                  </p>
                  <div className="col-md-4 pl-1 upload-row mb-2">
                    <div>
                      <button
                        style={{ height: "40px" }}
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          setShowConfirmationPopupForNoVoters(true);
                        }}
                      >
                        No Service Voters in This Constituency
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          ) : (
            ""
          )}
        </>
      </WorkingFlipDate>
    )
  ) : isSuccess && getAnnounceElectionDetail?.message !== "Success" ? (
    <NoElection data={"No Election Scheduled for your Constituency"} />
  ) : (
    ""
  );
};
export default FinalizeService;
